import { TFunction } from "i18next";
import {
	ClientFilterOption,
	ClientOrganizationSortColumn,
	ClientTableSortColumn,
} from "node-library/dist/paginations";
import { FrontendClient } from "node-library/dist/portal";

export function getClientFilterOptionString(
	option: ClientFilterOption,
	translation: TFunction<"translation", undefined>
): string {
	switch (option) {
		case ClientFilterOption.MY_CLIENTS:
			return translation("MyClients");
		case ClientFilterOption.UNASSIGNED:
			return translation("Unassigned");
	}
}

export function getClientSortString(
	sortColumn: ClientTableSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (sortColumn) {
		case ClientTableSortColumn.CLIENT_COMPANY_NAME:
			return translation("CompanyName");
		case ClientTableSortColumn.INSERTED:
			return translation("RegistrationTime");

		case ClientTableSortColumn.EMAIL:
			return translation("Email");

		case ClientTableSortColumn.FIRST_NAME:
			return translation("FirstName");
		case ClientTableSortColumn.LAST_NAME:
			return translation("LastName");
	}
}

export function getClientOrganizationSortString(
	sortColumn: ClientOrganizationSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (sortColumn) {
		case ClientOrganizationSortColumn.CLIENT_COMPANY_NAME:
			return translation("CompanyName");
		case ClientOrganizationSortColumn.INSERTED:
			return translation("RegistrationTime");

		case ClientOrganizationSortColumn.ASSOCIATION_ID:
			return translation("AssociationId");
	}
}
